<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :validate-on-rule-change="false"
      size="mini"
    >
      <!-- <h6 style="color: #101010;">
        {{ $l('form_label_base') || '基本信息' }}
      </h6> -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_requestDate') || '报价日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_cust') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              :selectedLabel.sync="formData.custName"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
              @change="custChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custContact') || '客户联系人'"
            prop="custContact"
          >
            <el-input
              v-model="formData.custContact"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custContactPhone') || '客户联系人电话'"
          >
            <el-input
              v-model="formData.custContactPhone"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custContactEmail') || '客户联系人邮箱'"
          >
            <el-input
              v-model="formData.custContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sampleSalesSeason') || '销售季节'"
            prop="sampleSalesSeason"
          >
            <dict-select
              v-model="formData.sampleSalesSeason"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sampleSalesSeason' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_custProjectNo') || '客户项目号'">
            <el-input
              v-model="formData.custProjectNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_dep') || '报价部门'"
            prop="depCode"
          >
            <!-- <dep-cascader
              size="mini"
              :lastValue.sync="formData.depCode"
              :valueString.sync="formData.displayDepCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            /> -->
            <el-input v-model="formData.orgDepFullName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_quotationRemark') || '备注说明'">
            <el-input
              v-model="formData.quotationRemark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <ChooseCustomerContacts
      :visible.sync="chooseCustomerContactsVisible"
      :title="`${formData.custName} ${$l('dialog_title_contacts') || '联系人'}`"
      :custCode="formData.custCode"
      @confirm="customerContactsConfirm"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseCustomerContacts from '@/views/digital/components/choose-customer-contacts'
export default {
  components: { ChooseCustomerContacts },
  mixins: [EditLoading],
  props: {
    quotationCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        requestDate: dayjs().format('YYYY-MM-DD'),
        custContact: '',
        custContactPhone: '',
        custContactEmail: '',
        depCode: '',
        orgDepFullName: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custContact: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        sampleSalesSeason: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message:
              this.$l('tips_cust_no_dep') || '当前客户无业务部门，请先维护',
            trigger: 'change',
          },
        ],
      },
      chooseCustomerContactsVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  watch: {
    userInfo: {
      handler() {
        if (this.quotationCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo || {}
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.quotationCode) return
      const data = await this.$api
        .customerQuotationDetailApi({ quotationCode: this.quotationCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.formData = data
      this.$emit('loaded', this.formData)
    },
    async reload() {
      if (!this.quotationCode) return
      const data = await this.$api
        .customerQuotationDetailApi({ quotationCode: this.quotationCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.$emit('loaded', data)
    },
    async custChange(custCode) {
      if (!custCode) return

      this.selectCustomerDep(custCode)
      this.selectCustomerContacts(custCode)
    },
    async selectCustomerDep(custCode) {
      if (!custCode) return

      const get = () => {
        if (!custCode) return
        return this.$api
          .masterCustomerV2DetailApi({ custCode })
          .then((res) => res.body)
          .catch(() => ({}))
      }

      const data = (await get()) || {}
      const { depCode, orgDepFullName } = data
      this.formData.depCode = depCode
      this.formData.orgDepFullName = orgDepFullName
    },
    async selectCustomerContacts(custCode) {
      if (!custCode) return

      const res = await this.$api
        .masterCustomerContactsListApi({ custCode })
        .catch(() => null)
      if (!res) return

      const data = res.body.data

      if (!data?.length) return
      if (data.length > 1) return (this.chooseCustomerContactsVisible = true)

      this.customerContactsConfirm(data[0])
    },
    customerContactsConfirm(data) {
      this.formData.custContact = data.contactName
      this.formData.custContactPhone = data.contactMobile
      this.formData.custContactEmail = data.contactEmail
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerQuotationSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status, body } = res
      if (status == 208) {
        this.$message.error(
          this.$l('tips_save_code208') ||
            '变更客户前需要先将之前客户的报价记录移除'
        )
        return
      }
      if (status !== 200 || !body) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.quotationCode && !this.isCopy) return this.getData()

      const { quotationCode, quotationNo } = body
      this.$router.replace({
        name: 'customerManage-customerQuotation-detail',
        params: { quotationCode, pageType: 'edit' },
        query: { quotationNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input-number .el-input__inner {
    text-align: start;
  }
}
</style>
